<template>
  <v-tab-item
    class="auctions"
    data-qa="item-tab-auctions">
    <v-skeleton-loader
      v-if="loading"
      :boilerplate="false"
      class="mt-4"
      :tile="false"
      type=" table-thead, table-tbody, table-tbody"
      width="100%"/>
    <template
      v-else>
      <EmptyBlock
        v-if="!auctions || !auctions.length"
        custom-class="mt-0 pa-10 no-auctions"
        data-qa="bids-noData"
        :text="$t('Tenders.NoData')"/>
      <v-data-table
        v-else
        calculate-widths
        class="tender-table auctions"
        disable-pagination
        fixed-header
        :headers="headers"
        hide-default-footer
        item-key="tenderId"
        :items="auctions"
        :no-data-text="$t('Tenders.NoData')">
        <template #[`item.tenderTitile`]="{ item }">
          <div class="tender-name-wrapper">
            <router-link
              class="tender-name h7-text-medium text-decoration-underline"
              :to=" {name: 'tenderitem', params: { id: item.tenderId, org: $route.params.org}} ">
              #{{ item.tenderNumber }}.  {{ item.tenderTitile }}
            </router-link>
          </div>
        </template>

        <template #[`item.tenderingPeriodFrom`]="{ item }">
          {{ formatBy(item.tenderingPeriodFrom, 'DD.MM.YYYY, HH:mm ') }}
        </template>

        <template #[`item.tenderPeriodTo`]="{ item }">
          {{ formatBy(item.tenderPeriodTo, 'DD.MM.YYYY, HH:mm ') }}
        </template>

        <template #[`item.tenderStatus`]="{ item }">
          <StatusChip
            key-name="statusCode"
            :status="item.tenderStatus"
            value-name="title"/>
        </template>
      </v-data-table>
    </template>
  </v-tab-item>
</template>
<script>
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import { modalMixin, tenderMixin } from 'mixins'

export default {
  name: 'auctionsTab',
  mixins: [ modalMixin, tenderMixin ],
  data() {
    return {
      headers: [
        { text: this.$t('Planning.Name') , value: 'tenderTitile', width: '25%'  },
        { text: this.$t('Tenders.PublicationDate') , value: 'tenderingPeriodFrom', width: '25%'},
        { text: this.$t('Tenders.EndDate'), value: 'tenderPeriodTo', width: '25%' },
        { text: this.$t('Purchasing.Status'), value: 'tenderStatus', width: '25%', sortable: false },
      ]
    }
  },
  props: {
    tender: Object,
    /**
     * [
        {
          'tenderId': 'tenderId',
          'tenderNumber': 'tenderNumber',
          'tenderTitile': 'tenderTitile',
          'tenderingPeriodFrom': 'tenderingPeriodFrom',
          'tenderPeriodTo': 'tenderPeriodTo',
          'tenderStatusTitle': 'tenderStatusTitle',
          'tenderStatus': {
            statusCode: 4,
            title: ''
          }
        },
      ]
     */
    auctions: Array,
    loading: Boolean,
  },
  components: {
    StatusChip,
    EmptyBlock
  }
}
</script>
